import { useEffect, useState } from "react";
import ErrorBoundary from "../../ErrorHandler/ErrorBoundary"
import NoticiaDetalhes from "../../NoticiaDetalhes"
import CorpoNoticia from "../../Postagens/Noticias/CorpoNoticia"
import api from "../../Services/api";


export type ICategoria = {
  Id: number;
  Title: string;
}
export interface INoticia {
  ID: number;
  id: number;
  Resumo: string;
  Title: string;
  UrlImagem: string;
  Categoria: ICategoria;
  DataInicio: string;
  Descricao: string;
  Corpo: string;
  Extra: string;
}

export interface NoticiaDetalhesProps {
  noticia: INoticia | undefined;
}

export const Detalhes = () => {

  const [noticia, setNoticia] = useState<INoticia>();
  var noticiaIdStr = window.location.toString().split('Id=')[1];

  useEffect(() => {
    var noticiaId = parseInt(noticiaIdStr);
    api.get(`ObterNoticiasDetalhada?Id=${noticiaIdStr}`).then(response => {

      const noticia = response.data.results.find(
        (noticiaCompleta: { Id: 0 }) => noticiaCompleta.Id === noticiaId
      );
      if (noticia) {
        setNoticia(noticia);
      } else {
        throw new Error("Noticia não encontrada");
      }
    }).catch(error => {
      throw new Error(error);
    });

  }, [noticiaIdStr]);

  return (
    <>
      <ErrorBoundary>
        <NoticiaDetalhes noticia={noticia} />
      </ErrorBoundary>
      <ErrorBoundary>
        <CorpoNoticia noticia={noticia} />
      </ErrorBoundary>
    </>
  )
}